<template>
    <div class="store-admin">
<!--        <h3 class="mb-3">Store Admin</h3>-->


        <div class="row">
            <!-- State Select -->
            <div class="col-6 form-group">
                <label for="state">State:</label>
                <b-select class="form-control" v-model="state" @change="getStateData">
                    <option value="DEFAULT">Default</option>
                    <option v-for="state in states" :key="state.state" :value="state.state">{{state.fullState}}</option>
                </b-select>
            </div>
            <!-- Save Buttons -->
            <div class="col-6 pr-5">
                <div class="row d-flex justify-content-end">
                    <b-btn class="border-dark" variant="light" :to="tabPreviewUrl()" target="_blank" :disabled="currentTab === null"  size="sm">
                        <font-awesome-icon :icon="['fal', 'eye']"></font-awesome-icon> Preview
                    </b-btn>
                    <b-btn class="ml-3 border-dark" @click="saveBlocks(true)" variant="primary" :disabled="saving" size="sm">
                        <template v-if="saving">
                            <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                        </template>
                        <template v-else>
                            Save Draft
                        </template>
                    </b-btn>
                    <b-btn class="ml-3 border-dark" variant="primary" @click="saveBlocks(false)" :disabled="saving"  size="sm">
                        <template v-if="saving">
                            <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                        </template>
                        <template v-else>
                            <font-awesome-icon :icon="['fal', 'save']"></font-awesome-icon> Save All & Publish
                        </template>
                    </b-btn>
                </div>
                <div class="row mt-3 d-flex justify-content-end">
                    <b-checkbox v-model="homeschool" @change="toggleHomeschool()">Homeschool Store</b-checkbox>
                </div>
            </div>
        </div>

        <!-- Tabs -->
        <b-tabs content-class="mt-3">

            <!-- Misc Tab -->
            <b-tab title="Misc" active @click="currentTab = null">
                <div v-if="loadingStateData">
                    <font-awesome-icon :icon="['far', 'circle-notch']" spin />
                </div>
                <div v-else>
                    <EditorBlock title="Messaging">
                        <label>Navbar Message</label>
                        <TipTapEditor v-model="messages.navMessage" :simple="true" />
                    </EditorBlock>

                </div>
            </b-tab>

            <!-- Landing Page -->
            <b-tab title="Landing Page" @click="currentTab = 'blocks'">
                <div v-if="loadingStateData">
                    <font-awesome-icon :icon="['far', 'circle-notch']" spin />
                </div>
                <div v-else>
                    <StateProductBlock :messages.sync="messages" :blocks.sync="blocks" page="landing" :noDesc="true"  @remove="removeBlock"/>
                </div>
            </b-tab>

            <!-- Social Studies -->
            <b-tab title="Social Studies" @click="currentTab = 'ss_blocks'">
                <div v-if="loadingStateData">
                    <font-awesome-icon :icon="['far', 'circle-notch']" spin />
                </div>
                <div v-else>
                    <StateProductBlock :messages.sync="messages" :blocks.sync="ss_blocks" page="social_studies" @remove="removeBlock"/>
                </div>
            </b-tab>

            <!-- Science -->
            <b-tab title=" Science" @click="currentTab = 'sn_blocks'">
                <div v-if="loadingStateData">
                    <font-awesome-icon :icon="['far', 'circle-notch']" spin />
                </div>
                <div v-else>
                    <StateProductBlock :messages.sync="messages" :blocks.sync="sn_blocks" page="science" @remove="removeBlock" />
                </div>
            </b-tab>

            <!-- Well Being -->
            <b-tab title="Well Being" @click="currentTab = 'wb_blocks'">
                <div v-if="loadingStateData">
                    <font-awesome-icon :icon="['far', 'circle-notch']" spin />
                </div>
                <div v-else>
                    <StateProductBlock :messages.sync="messages" :blocks.sync="wb_blocks" page="well_being" @remove="removeBlock"/>
                </div>
            </b-tab>

            <!-- Summer -->
            <b-tab title="ELA/Summer" @click="currentTab = 'summer_blocks'">
                <div v-if="loadingStateData">
                    <font-awesome-icon :icon="['far', 'circle-notch']" spin />
                </div>
                <div v-else>
                    <StateProductBlock :messages.sync="messages" :blocks.sync="summer_blocks" page="well_being" @remove="removeBlock"/>
                </div>
            </b-tab>

            <!-- PreK -->
            <b-tab title="PreK" @click="currentTab = 'prek_blocks'">
                <div v-if="loadingStateData">
                    <font-awesome-icon :icon="['far', 'circle-notch']" spin />
                </div>
                <div v-else>
                    <StateProductBlock :messages.sync="messages" :blocks.sync="prek_blocks" page="well_being" @remove="removeBlock"/>
                </div>
            </b-tab>
        </b-tabs>

        <!-- Footer Btns -->
        <div class="mt-3 mb-5">
            <div class="d-inline float-left">
                <b-dropdown text="Add a Block" v-if="currentTab != null">
                    <b-dropdown-item @click="addBlock(currentTab, 'html')">
                        HTML Editor
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock(currentTab, 'raw')">
                        Text Editor
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock(currentTab, 'double_column')">
                        2 Column Text Editor
                    </b-dropdown-item>
                    <b-dropdown-item @click="addBlock(currentTab, 'flipbook')">
                        Flip Book
                    </b-dropdown-item>
<!--                    <b-dropdown-item @click="addBlock(currentTab, 'national_materials')">-->
<!--                        National Materials-->
<!--                    </b-dropdown-item>-->
                    <b-dropdown-item @click="addBlock(currentTab, 'wyg')">
                        What You Get / Key Features
                    </b-dropdown-item>
<!--                    <b-dropdown-item @click="addBlock(currentTab, 'online')">-->
<!--                        Studies Weekly Online-->
<!--                    </b-dropdown-item>-->
    <!--                                    <b-dropdown-item @click="addBlock(currentTab, 'flip')">-->
    <!--                                        Flip Book-->
    <!--                                    </b-dropdown-item>-->
                </b-dropdown>
            </div>
            <div class="d-inline float-right">
                <b-btn class="border-dark" @click="saveBlocks(true)" variant="primary" :disabled="saving" size="sm">
                    <template v-if="saving">
                        <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                    </template>
                    <template v-else>
                        Save Draft
                    </template>
                </b-btn>
            </div>
            <br/>
            <br/>
            <br/>
        </div>
    </div>
</template>


<script>




import states, {publicationStates} from '@/common/states'

import RawBuilder from '@/components/dashboard/storeadmin/blocks/Raw'
import WYGBuilder from '@/components/dashboard/storeadmin/blocks/WhatYouGet'
import TeacherMaterialsBuilder from '@/components/dashboard/storeadmin/blocks/TeacherMaterials'
import StudentMaterialsBuilder from '@/components/dashboard/storeadmin/blocks/StudentMaterials'
import NationalMaterialsBuilder from '@/components/dashboard/storeadmin/blocks/NationalMaterials'
import OnlineBuilder from '@/components/dashboard/storeadmin/blocks/Online'
import ScienceBlurbBuilder from '@/components/dashboard/storeadmin/blocks/ScienceBlurb'
import SSLandingBuilder from '@/components/dashboard/storeadmin/blocks/SSLanding'
import TipTapEditor from "@/components/tiptap/TipTapEditor";
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
import FlipBook from "@/components/dashboard/storeadmin/blocks/FlipBook";
import StateProductBlock from "@/components/dashboard/storeadmin/StateProductBlock";
import {mapGetters} from "vuex";

export default {
    name: 'store-admin',
    data: () => ({
        html: '<div><div> <div><h1>Expand your Teaching <span class="text-purple">IN CLASS</span> and through <span class="text-purple">REMOTE LEARNING</span></h1></div> <img-node src="//cdn.studiesweekly.com/store/pages/wellbeing/Well-being+Print+version+and+ipad.png" width="50%"></img-node><div><p style="line-height: 28px">Teach and <strong class="text-purple">support social-emotional learning</strong> and discussion <strong class="text-purple">in or out of the classroom</strong></p></div></div></div>',
        blocks: [],
        ss_blocks: [],
        sn_blocks: [],
        summer_blocks: [],
        prek_blocks: [],
        currentTab: null,
        nat_ss_blocks: [],
        wb_blocks: [],
        contentBlocks: {
            landing: {},
            misc: {},
        },
        homeschool: false,

        messages: {},

        states: publicationStates,

        navMessage: null,

        state: "DEFAULT",
        product_bg: null,
        saving: false,
        loadingStateData: false
    }),
    components: {
        StateProductBlock,
        FlipBook,
        EditorBlock,
        TipTapEditor,
        RawBuilder,
        WYGBuilder,
        TeacherMaterialsBuilder,
        StudentMaterialsBuilder,
        NationalMaterialsBuilder,
        OnlineBuilder,
        ScienceBlurbBuilder,
        SSLandingBuilder
    },
    methods: {

        tabPreviewUrl() {
            let state = (this.state === 'DEFAULT') ? 'UT' : this.state;
            let grade = 0;
            let lang = "en";

            let page_urls = {
                'null': '',
                blocks: '?preview=1',
                ss_blocks: `social-studies/${state}/${grade}/${lang}?preview=1`,
                sn_blocks: `science/${state}/${grade}/${lang}?preview=1`,
                wb_blocks: `well-being/${state}/${grade}/${lang}?preview=1`,
                summer_blocks: `summer-school/${state}/${grade}/${lang}?preview=1`,
                prek_blocks: `pre-k/${state}/${grade}/${lang}?preview=1`,
            }

            let url = '/' + page_urls[this.currentTab];
            return url;
        },

        // Blocks
        getStateData () {
            this.loadingStateData = true

            let state
            if (this.state) {
                state = this.state
            } else {
                state = 'DEFAULT'
            }

            this.$http({
                'url': `dashboard/state/data/${this.state}`,
                'method': 'GET',
                'params': {
                    draft: 1,
                    homeschool: this.homeschool ? 1 : 0,
                }
            }).then((response) => {
                this.loadingStateData = false

                if (response.data.blocks) {
                    this.blocks = response.data.blocks
                }
                if (response.data.wb_blocks) {
                    this.wb_blocks = response.data.wb_blocks
                }
                if (response.data.ss_blocks) {
                    this.ss_blocks = response.data.ss_blocks
                }
                if (response.data.sn_blocks) {
                    this.sn_blocks = response.data.sn_blocks
                }
                if (response.data.summer_blocks) {
                    this.summer_blocks = response.data.summer_blocks
                }
                if (response.data.prek_blocks) {
                    this.prek_blocks = response.data.prek_blocks
                }
                if (response.data.motd) {
                    this.message = response.data.motd
                }
                if (response.data.product_bg) {
                    this.product_bg = response.data.product_bg
                }
                if (response.data.nat_ss_blocks) {
                    this.nat_ss_blocks = response.data.nat_ss_blocks
                }
                if (response.data.messages) {
                    this.messages = response.data.messages;
                }
            })
        },
        addBlock (target, type) {
            switch(type) {
                case "html":
                    this[target].push({type: 'html', value: "<section>placeholder</section>"});
                    break;
                case "flipbook":
                    this[target].push({type: 'flipbook', title: "", books: [{image: "", id: null, label: ""}]});
                    break;
                case "raw":
                    this[target].push({ type: 'raw', value: 'placeholder' })
                    break;
                case "double_column":
                    this[target].push({type: 'double_column', value: ["placeholder1", "placeholder2"]})
                    break;
                case "wyg":
                    this[target].push({ type: 'wyg', wyg: [], kf: [], button_label: '', button_uri: '' })
                    break;
                case "national_materials":
                    this[target].push({ type: 'national_materials'})
                    break;
                case "teacher_materials":
                    this[target].push({ type: 'teacher_materials'})
                    break;
                case "student_materials":
                    this[target].push({ type: 'student_materials'})
                    break;
                case "online":
                    this[target].push({ type: 'online'})
                    break;
                case "science_blurb":
                    this[target].push({ type: 'science_blurb'})
                    break;
                case "ss_landing":
                    this[target].push({ type: 'ss_landing', bgImage: '//cdn.studiesweekly.com/store/Blog-Header-19-640x335.png'})
                    break;
                case "flip":
                    this[target].push({type: 'flip', books: []});
                    break;
            }
        },
        removeBlock (index, target) {
            let that = this;
            this.$swal({
                text: 'Are you sure you want to delete this block?',
                showCancelButton: true,
                confirmButtonText: 'Delete Block',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-light',
                buttonsStyling: false
            }).then((result) => {
                if (result.value) {
                    target.splice(index, 1);
                }
            })
        },

        saveBlocks (saveAsDraft) {
            this.saving = true

            return this.$http({
                'url': 'dashboard/state/save',
                'method': 'POST',
                data: {
                    blocks: JSON.stringify(this.blocks),
                    nat_ss_blocks: JSON.stringify(this.nat_ss_blocks),
                    ss_blocks: JSON.stringify(this.ss_blocks),
                    sn_blocks: JSON.stringify(this.sn_blocks),
                    wb_blocks: JSON.stringify(this.wb_blocks),
                    summer_blocks: JSON.stringify(this.summer_blocks),
                    prek_blocks: JSON.stringify(this.prek_blocks),
                    motd: this.message,
                    product_bg: this.product_bg,
                    state: this.state,
                    messages: JSON.stringify(this.messages),
                    draft: saveAsDraft ? 1 : 0,
                    homeschool: this.homeschool ? 1 : 0,
                }
            }).then((response) => {
                this.saving = false

                // clear old state data
                this.$store.commit("setStateData", {})

                let html = "Changes Published";
                if (saveAsDraft)
                    html = "Changes saved as draft";

                this.$swal({
                    toast: true,
                    html: html,
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })

                // reload state data, TODO: fix and remember why we added this.
                this.$store.getStateData()


            })
        },
        saveAsDraft() {
            //this.$store.dispatch('saveProductPage', this.html);
        },
        sortData(data) {
            // Sorts block data by page and key. to look like {landing: {bg-img: "content"}...},
            let blocksByPage = {};
            _.forEach(data, (block) => {
                let key = block.key ? block.key : 'editor';

                if (!blocksByPage.hasOwnProperty(block.page))
                    blocksByPage[block.page] = {};

                if (key === 'editor') {
                    if (!blocksByPage[block.page].hasOwnProperty(key))
                        blocksByPage[block.page][key] = [];

                    blocksByPage[block.page][key].push(block);
                    return;
                }

                blocksByPage[block.page][key] = block;
            });
            this.contentBlocks = blocksByPage;
        },
        toggleHomeschool() {
            this.$store.dispatch('setAsHomeschoolStore', this.homeschool)
                .then(() => {
                    this.getData();
                })
        },
        getData() {
            this.getStateData();
            this.$store.dispatch('getStateBlocks', 'default')
                .then(this.sortData);
        },
        bindHotkeys() {
            document.addEventListener('keydown', e => {
                if ((e.ctrlKey || e.metaKey) && e.key === 's') {
                    e.preventDefault();
                    this.saveBlocks(true);
                }
            });
        }

    },
    computed: {
        stateData: state => state.stateData.stateData,
        selectedState: state => state.stateData.selectedState,
    },
    created() {
        this.homeschool = this.$store.getters.isHomeschoolStore;
    },
    mounted () {
        this.getData();
        this.bindHotkeys();
    }
}
</script>


<style>
.callout-pin {
    position: absolute;
    color: red;
    width: 35px !important;
    height: 35px;
}
.block + .block {
    margin-top: 1.5rem;
}
.block .delete {
    position: absolute;
    right: -15px;
    top: -15px;
    border-radius: 100%;
    border: 0;
    padding: 3px 10px;
    z-index: 10;
}
.block .moveup {
     position: absolute;
     right: -55px;
     top: -15px;
     border-radius: 100%;
     border: 0;
     padding: 3px 10px;
     z-index: 10;
}
.block .movedown {
    position: absolute;
    right: -55px;
    top: 25px;
    border-radius: 100%;
    border: 0;
    padding: 3px 10px;
    z-index: 10;
}
.block .move-btn {
    opacity: 0.2;
}
.block .move-btn:hover {
    opacity: 1.0;
}
.maxw-100 {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
}
</style>
